import { HubConnection, HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import React, { useEffect, useState } from "react";
import { getIsLoggedIn } from "src/app-redux/auth/authSlice";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { getAllNotifications } from "src/app-redux/notifications/actions/notificationActions";
import {
  allNotificationsList,
  setAllNotifications,
  setUnreadCount,
} from "src/app-redux/notifications/notificationSlice";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

export interface INotificationConnectionProps {}

export default function NotificationConnection(props: INotificationConnectionProps) {
  const [connection, setConnection] = useState<null | HubConnection>(null);
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(getIsLoggedIn);
  const allNotifications = useAppSelector(allNotificationsList);
  const [latestNotification, setlatestNotification] = useState<any>({});

  useEffect(() => {
    dispatch(setAllNotifications([latestNotification, ...allNotifications]));
  }, [latestNotification]);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      const connect = new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_API_URL}/message`, {
          // .withUrl("http://localhost:5000/message", {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();
      setConnection(connect);
    } else {
      connection?.stop();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    startSignalRConnection();
  }, [connection]);

  const getNotifications = async () => {
    const body = {
      userId: Number(localStorage.getItem("nodUserId")),
      pageNumber: 0,
    };
    const res = await dispatch(getAllNotifications(body));
    if (res.payload?.notificationList) {
      dispatch(setUnreadCount(res.payload.unreadnotificationCount));
    }
  };

  const startSignalRConnection = () => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on("sendNotification", (message, unReadCount, newNotification) => {
            dispatch(
              addNotificationAction({
                message: message,
                options: { variant: "warning" },
              })
            );

            dispatch(setUnreadCount(unReadCount));
            setlatestNotification(newNotification);
            // getNotifications();
          });
          connection.on("Welcome", (data) => {
            console.log("Welcome :: ", data);

            connection.invoke("GatDataFromClient", localStorage.getItem("userName"), data);
          });
        })
        .catch((error) => console.log("error :::: ", error));

      getNotifications();
    }
  };

  return <></>;
}
